/*
 *
 * Api reducer
 *
 */

import produce from 'immer';

import _ from 'lodash';
import { REQUEST_DATA_RESULT } from '../App/constants';

export const initialState = {};

export const loginReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case REQUEST_DATA_RESULT:
        switch (action.id) {
        }
    }
  });
};
